import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";

export const productionMethodsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getProductionMethodsList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.productionMethods }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getProductionMethodsById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.productionMethods }/${ id }`,
		method: 'GET',
	  }),
	}),

	addProductionMethods: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.productionMethods }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editProductionMethods: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.productionMethods }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteProductionMethodse: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.productionMethods }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddProductionMethodsMutation,
  useDeleteProductionMethodseMutation,
  useEditProductionMethodsMutation,
  useGetProductionMethodsByIdQuery,
  useGetProductionMethodsListQuery,
  useLazyGetProductionMethodsListQuery
} = productionMethodsApi;
